module.exports = __webpack_public_path__ + "static/media/modelB4.6483a0d9.gif";